<template>
  <footer class="bg-lu-gray-dark text-white py-4 w-full" :class="pinBottom ? 'pin-b' : ''">
    <div class="flex flex-wrap xl:w-2/3 xl:mx-auto">
      <contact-footer :contact-links="contactLinks" :feedback="feedback" class="border-b border-gray-500" />
      <legal-footer :links="legalLinks" />
    </div>
  </footer>
</template>

<script>
import LegalFooter from './LegalFooter'
import ContactFooter from './ContactFooter'

export default {
  name: 'FullFooter',
  components: {
    LegalFooter,
    ContactFooter
  },
  props: {
    contactLinks: {
      type: Array,
      default: () => {
        return []
      }
    },
    feedback: {
      type: Object,
      default: () => {
        return null
      }
    },
    legalLinks: {
      type: Array,
      default: () => {
        return []
      }
    },
    pinBottom: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
  /* purgecss start ignore */
  @tailwind  base;
  @tailwind  components;
  /* purgecss end ignore */

  @tailwind utilities;

</style>
